<m-input-style
    class="m-rich-text"
    :disabled="isDisabled"
    :waiting="isWaiting"
    :error="hasError"
    :valid="isValid"
    :label="label"
    :label-for="id"
    :focus="isFocus"
    :empty="isEmpty"
    :border-top="!readonly"
    :required-marker="requiredMarker"
    :tag-style="tagStyle"
    :readonly="readonly"
    :error-message="errorMessage"
    :valid-message="validMessage"
    :helper-message="helperMessage"
    :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
    @click.stop="onClick"
>
    <froala
        :value="value"
        :config="internalOptions"
        :disabled="disabled || waiting"
        :custom-translations="customTranslations"
        :image-upload-custom-validation="imageUploadCustomValidation"
        ref="input"
        :readonly="readonly"
        :min-rows="minRows"
        :required="required || requiredMarker"
        @input="refreshModel"
        @focus="onFroalaFocus"
        @blur="onFroalaBlur"
        @keyup="onKeyup"
        @keydown="keydown"
        @paste="onPaste"
        @image-ready="imageReady"
        @image-added="imageAdded"
        @image-removed="imageRemoved"
        @fullscreen="onFullscreen"
    />
    <m-validation-message
        slot="validation"
        class="m-rich-text__validation-message"
        :disabled="isDisabled"
        :waiting="isWaiting"
        :error="hasError"
        :error-message="errorMessage"
        :valid="isValid"
        :valid-message="validMessage"
        :helper-message="helperMessage"
    />
</m-input-style>
